import { useEffect, useState } from 'react';
import { DeepLinkHandler } from '../utils/DeepLinkHandler';

export const useDeepLink = () => {
  const [deepLinkAction, setDeepLinkAction] = useState(null);

  useEffect(() => {
    // Check for deep link on initial load
    const initialAction = DeepLinkHandler.checkCurrentUrl();
    if (initialAction) {
      setDeepLinkAction(initialAction);
    }

    // Listen for URL changes
    const handleUrlChange = () => {
      const action = DeepLinkHandler.checkCurrentUrl();
      if (action) {
        setDeepLinkAction(action);
      }
    };

    window.addEventListener('popstate', handleUrlChange);
    return () => window.removeEventListener('popstate', handleUrlChange);
  }, []);

  return deepLinkAction;
}; 